import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { resetOrderedItemsReport } from '../../../actions/reports/ordered-items';
import { fetchReservationOrderedItemsReport } from '../../../sagas/reports/routines';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchOrderedItemsReportHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const resetOrderedItemsReportHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchOrderedItemsReportHandler(fetchReservationOrderedItemsReport),
  ...resetOrderedItemsReportHandler(resetOrderedItemsReport)
});
